// extracted by mini-css-extract-plugin
export default {"centered":"LoginPage_centered__P0+PQ","loginBox":"LoginPage_loginBox__pgz5x"};